import type { ReactNode } from 'react'
import type { ConversationViewModel } from '@/features/messages/ConversationViewModel'
import { observer } from 'mobx-react-lite'
import { ConversationMessageComposer } from '@/features/messages/components/ConversationMessageComposer/index'

interface ConversationMessageComposerContainerProps {
  vm: ConversationViewModel

  /** @see ConversationMessageComposerProps.stackAfter */
  stackAfter?: number

  /** @see ConversationMessageComposerProps.suggestions */
  suggestions?: readonly string[]

  /** @see ConversationMessageComposerProps.testId */
  testId?: string

  /** @see ConversationMessageComposerProps.textareaTestId */
  textareaTestId?: string

  /** @see ConversationMessageComposerProps.sendButtonTestId */
  sendButtonTestId?: string

  /** @see ConversationMessageComposerProps.leadingActions */
  leadingActions?: ReactNode
}

/**
 * Container component for the conversation message composer.
 */
export const ConversationMessageComposerContainer = observer(
  function ConversationMessageComposerContainer({
    vm,
    stackAfter,
    suggestions,
    testId,
    textareaTestId,
    sendButtonTestId,
    leadingActions,
  }: ConversationMessageComposerContainerProps) {
    return (
      <ConversationMessageComposer
        onSelectSuggestion={vm.send}
        onSend={vm.sendCurrentMessage}
        onChange={vm.setMessageText}
        value={vm.messageText}
        stackAfter={stackAfter}
        suggestions={suggestions}
        disableSendOnEnter
        testId={testId}
        textareaTestId={textareaTestId}
        sendButtonTestId={sendButtonTestId}
        leadingActions={leadingActions}
      />
    )
  },
)
